
// auth.js
import { PublicClientApplication } from "@azure/msal-browser";
import { HEEDIFY_REDIRECT_URI } from "./config/config.js";

export const msalConfig = {
  auth: {
    clientId: "2648d652-0325-425a-88a4-fd99068b32a8",
    authority: "https://login.microsoftonline.com/common",
    redirectUri: HEEDIFY_REDIRECT_URI,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

// handle redirect response
export async function initializeMsal() {
  if (!msalInstance.initialized) {
    await msalInstance.initialize();
    msalInstance.initialized = true;
  }

  // process redirect result if available
  const response = await msalInstance.handleRedirectPromise();
  if (response && response.account) {
    msalInstance.setActiveAccount(response.account);
  } else {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
    }
  }
}


